import React, { useContext } from 'react'
import { ThemeContext } from 'styled-components'
import PropTypes from 'prop-types'
import styled from 'styled-components'
const StyledImage = styled.img`
    display : ${props => props.display || 'flex'} ;
    justify-content : ${props => props.justifyContent || 'flex-start'};
    align-items : ${props => props.alignItems || 'center'};
    width : ${props => props.width || 'auto'};
    height : ${props => props.height || 'auto'};
    margin : ${props => props.margin || '0px 5px 0px 5px'} ;
    border: ${props => props.style ? props.style.border : 'none'};
    outline : 'none';
    `
const Image = props => {
    const theme = useContext(ThemeContext)

    return (
        <StyledImage
            className={props.className}
            theme={theme} {...props} src={props.src} onClick={props.onClick} />
    )
}
export default Image
